import { StanInput } from '@/components';
import { SectionHeader } from './SectionHeader';

const FUNNEL_CTA_MAX_LENGTH = 60;

interface FunnelOverridesSectionProps {
    pageId: number;
    priceSectionNumber: number | null;
    ctaSectionNumber: number;
    currencySymbol: string;
    storePriceLabel: string | null;
    funnelPriceInput: string;
    funnelCtaText: string;
    defaultCtaText: string;
    disabled?: boolean;
    onFunnelPriceChange: (value: string) => void;
    onFunnelCtaTextChange: (value: string) => void;
}

export const FunnelOverridesSection = ({
    pageId,
    priceSectionNumber,
    ctaSectionNumber,
    currencySymbol,
    storePriceLabel,
    funnelPriceInput,
    funnelCtaText,
    defaultCtaText,
    disabled,
    onFunnelPriceChange,
    onFunnelCtaTextChange,
}: FunnelOverridesSectionProps) => (
    <>
        {priceSectionNumber !== null && storePriceLabel !== null && (
            <div className='flex flex-col gap-4 md:gap-6'>
                <SectionHeader number={priceSectionNumber} title='Funnel Price' />
                <div className='flex flex-col gap-2'>
                    <p className='text-body-sm text-dark'>Override the store price for this funnel step (optional).</p>
                    <div className='flex items-center gap-3'>
                        <span className='text-body-md text-gray shrink-0'>{currencySymbol}</span>
                        <div className='flex-1'>
                            <StanInput
                                id={`funnel-price-${pageId}`}
                                name={`funnel-price-${pageId}`}
                                type='number'
                                min={0}
                                step='0.01'
                                inputMode='decimal'
                                placeholder={`e.g. ${storePriceLabel.replace(/[^\d.]/g, '')}`}
                                value={funnelPriceInput}
                                disabled={disabled}
                                onChange={e => onFunnelPriceChange(e.target.value)}
                            />
                        </div>
                    </div>
                    <p className='text-body-sm text-gray'>
                        Leave blank to use the store price:{' '}
                        <span className='text-dark font-medium'>{storePriceLabel}</span>
                    </p>
                </div>
            </div>
        )}

        <div className='flex flex-col gap-4 md:gap-6'>
            <SectionHeader number={ctaSectionNumber} title='Button Text' />
            <div className='flex flex-col gap-2'>
                <p className='text-body-sm text-dark'>Customize the CTA button text for this funnel step (optional).</p>
                <StanInput
                    id={`funnel-cta-${pageId}`}
                    name={`funnel-cta-${pageId}`}
                    type='text'
                    maxLength={FUNNEL_CTA_MAX_LENGTH}
                    placeholder={defaultCtaText || 'e.g. Yes! Add This To My Order'}
                    value={funnelCtaText}
                    disabled={disabled}
                    onChange={e => onFunnelCtaTextChange(e.target.value)}
                />
                <p className='text-body-sm text-gray'>
                    {defaultCtaText ? (
                        <>
                            Leave blank to use the product’s default:{' '}
                            <span className='text-dark font-medium'>“{defaultCtaText}”</span>
                        </>
                    ) : (
                        'Leave blank to use the product’s default button text.'
                    )}
                </p>
            </div>
        </div>
    </>
);
